"use client";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Textarea } from "@/components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { handleFormChange } from "@/utils/formChange";
import { Plus, Car, Ship, Bus, Truck, Loader2 } from "lucide-react";
import { FC, FormEvent, useEffect, useState } from "react";
import SelectFinal from "@/components/input/Select";
import axios from "axios";
import { BASE_URL } from "@/config";
import { useRefresh } from "react-admin";
import CommonCreate from "@/components/common/Create";
import VehicleForm from "./VehicleForm";
import { boolean } from "zod";

const CreateVehicle = () => {
  const refresh = useRefresh();

  const [formProp, setFormProp] = useState({
    type: "car",
    license_plate: "",
    make_id: "",
    identification_vin: "",
    make_model: "",
    make_year: "",
    km_type: "km",
    two_tanks: "no",
    nickname: "",
    notes: "",
    primary_tank_value: "",
    secondary_tank_value: ""
  });
  const [tanks, setTanks] = useState({
    primaryTankId: "",
    secondaryTankId: "",
    primary_tank_value: "",
    secondary_tank_value: ""
  });

  return (
    <CommonCreate
      title="Create vehicle"
      resource="vehicles"
      data={{
        data: {
            ...formProp,
            make_id: Number(formProp.make_id),
            two_tanks: formProp.two_tanks === "yes" ? true : false,
            license_plate: formProp.license_plate.toUpperCase(),
        },
        tanks: [
            tanks.primaryTankId && {
                fuel_id: Number(tanks.primaryTankId),
                unit_capacity: Number(tanks.primary_tank_value),
                type: "PRIMARY",
            },
            tanks.secondaryTankId && {
                fuel_id: Number(tanks.secondaryTankId),
                unit_capacity: Number(tanks.secondary_tank_value),
                type: "SECONDARY",
            }
        ].filter((item) => typeof item !== "string")
      }}
      responseMessage="Vehicle added to your fleet!"
    >
      <VehicleForm mode="create" formProp={formProp} setFormProp={setFormProp} otherData={tanks} setOtherData={setTanks} />
    </CommonCreate>
  );
};

export default CreateVehicle;
